var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.285645,
    y: 0.00119019,
    width: 35,
    height: 23.3363,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5237 11.729C12.5237 13.0188 13.5025 14.0187 14.7614 14.0187C15.1176 14.0187 15.422 13.946 15.7981 13.7631V12.7558C15.4676 13.0978 15.1748 13.2361 14.7998 13.2361C13.9669 13.2361 13.3758 12.6112 13.3758 11.7226C13.3758 10.8805 13.986 10.2159 14.7614 10.2159C15.1559 10.2159 15.4546 10.3612 15.7981 10.7093V9.70228C15.4354 9.51195 15.1367 9.43291 14.7809 9.43291C13.5282 9.43291 12.5237 10.4533 12.5237 11.729Z",
    fill: "#251F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4014 10.6635C10.4014 10.9003 10.5473 11.0258 11.0435 11.2158C11.9843 11.572 12.2631 11.8874 12.2631 12.5846C12.2631 13.4339 11.66 14.0251 10.8007 14.0251C10.1716 14.0251 9.71404 13.7688 9.33286 13.19L9.86712 12.6576C10.0575 13.0387 10.3753 13.2428 10.7695 13.2428C11.1387 13.2428 11.4117 12.9795 11.4117 12.624C11.4117 12.4396 11.3288 12.2812 11.1637 12.1699C11.0805 12.1171 10.9158 12.0381 10.5921 11.92C9.81541 11.6308 9.54896 11.3214 9.54896 10.7167C9.54896 9.9986 10.1212 9.45949 10.8712 9.45949C11.336 9.45949 11.7613 9.62395 12.1172 9.94614L11.6843 10.5324C11.4689 10.2825 11.2654 10.1769 11.0175 10.1769C10.661 10.1769 10.4014 10.3871 10.4014 10.6635Z",
    fill: "#251F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53828 9.53216H4.32422V13.9198H5.53177C6.17357 13.9198 6.63762 13.7631 7.04447 13.4133C7.52804 12.999 7.81401 12.3744 7.81401 11.729C7.81401 10.4342 6.87906 9.53216 5.53828 9.53216ZM6.50405 12.8285C6.24412 13.0709 5.90678 13.1769 5.37252 13.1769H5.1506V10.2758H5.37252C5.90678 10.2758 6.23076 10.3743 6.50405 10.6306C6.79036 10.8939 6.96194 11.3022 6.96194 11.7226C6.96194 12.1437 6.79036 12.5651 6.50405 12.8285Z",
    fill: "#251F1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02157 9.53216H8.1945V13.9198H9.02157V9.53216Z",
    fill: "#251F1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2242 9.53216L22.355 12.479L23.5002 9.53216H24.3965L22.565 14.0325H22.1201L20.3211 9.53216H21.2242Z",
    fill: "#251F1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7705 13.9198H27.1157V13.1769H25.5969V11.9927H27.0595V11.2494H25.5969V10.2758H27.1157V9.53216H24.7705V13.9198Z",
    fill: "#251F1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8894 9.53216C29.8432 9.53216 30.3904 10.006 30.3904 10.8273C30.3904 11.4993 30.0469 11.9402 29.424 12.0714L30.7586 13.9198H29.7418L28.5972 12.1572H28.489V13.9198H27.6633V9.53216H28.8894ZM28.489 11.5521H28.7311C29.2592 11.5521 29.539 11.3146 29.539 10.8737C29.539 10.4466 29.2592 10.223 28.7438 10.223H28.489V11.5521Z",
    fill: "#251F1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0494 9.7622C31.0494 9.68493 30.9976 9.64275 30.9076 9.64275H30.7877V10.0298H30.8767V9.87987L30.9812 10.0298H31.0905L30.9675 9.8703C31.0199 9.85541 31.0494 9.81572 31.0494 9.7622ZM30.8918 9.81501H30.8767V9.71364H30.8928C30.937 9.71364 30.96 9.7303 30.96 9.76361C30.96 9.79764 30.9367 9.81501 30.8918 9.81501Z",
    fill: "#251F1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5997 9.83555C30.5997 9.64805 30.7442 9.49812 30.9254 9.49812C31.1021 9.49812 31.2473 9.65088 31.2473 9.83555C31.2473 10.0213 31.1021 10.173 30.9254 10.173C30.7456 10.173 30.5997 10.0227 30.5997 9.83555ZM30.6644 9.8359C30.6644 9.98973 30.7812 10.1127 30.924 10.1127C31.0665 10.1127 31.1822 9.98831 31.1822 9.8359C31.1822 9.68491 31.0665 9.55873 30.924 9.55873C30.7802 9.55873 30.6644 9.68207 30.6644 9.8359Z",
    fill: "#251F1F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3399_9462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3044 14.0531C17.0653 14.0531 16.0605 13.0132 16.0605 11.7308V11.7276C16.0605 11.0896 16.3102 10.5091 16.7139 10.0912C16.7139 10.088 16.7171 10.088 16.7171 10.0848C16.7201 10.0848 16.7201 10.0816 16.7232 10.0816C17.127 9.66371 17.688 9.40535 18.3044 9.40535H18.3075C19.5466 9.40535 20.5514 10.4453 20.5514 11.7276V11.7308C20.5514 12.3688 20.3017 12.9462 19.8979 13.3673C19.8979 13.3705 19.8949 13.3705 19.8949 13.3737C19.8918 13.3737 19.8918 13.3769 19.8887 13.3769C19.4818 13.7947 18.9239 14.0531 18.3075 14.0531H18.3044Z",
    fill: "url(#paint0_linear_3399_9462)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3399_9462",
    x: 16.0605,
    y: 9.40535,
    width: 5.46765,
    height: 6.11314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.976924,
    dy: 1.46539
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.976924
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3399_9462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3399_9462",
    x1: 17.1291,
    y1: 9.40535,
    x2: 20.9242,
    y2: 12.5083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#F04D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7911D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.c86dacea6ebdcadb0c22c074d56a8b29.svg";
export { ForwardRef as ReactComponent };